const cartDrawer = document.getElementById("cartDrawer");
const closeCartButton = document.querySelector(".closeCart");
const cartTotal = document.querySelector(".cartTotal");
const cartItemsContainer = document.querySelector(".cartLines");
const drawerCheckout = document.querySelector(".drawerCheckout");
const drawerCheckoutShipping = document.querySelector("#confirmShippingTime");
const cartOpenButton = document.querySelector("#cartOpenButton");
const cartOpenButtonMobile = document.querySelector("#cartOpenButtonMobile");

//   Event Listeners ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

const params = new URLSearchParams(window.location.search);
if (params.get("cart") === "open") {
  openCartDrawer();
}

cartOpenButton && cartOpenButton.addEventListener("click", (e) => {
  e.preventDefault();
  openCartDrawer();
});
cartOpenButtonMobile && cartOpenButtonMobile.addEventListener("click", (e) => {
  e.preventDefault();
  openCartDrawer();
});

// Open cart drawer
function openCartDrawer() {
  cartDrawer.classList.add("open");
  fetchCart();
}

// Close cart drawer
function closeCartDrawer() {
  cartDrawer.classList.remove("open");
}
closeCartButton.addEventListener("click", closeCartDrawer);

// Optional: Automatically close the cart drawer when clicking outside of it
document.addEventListener("click", (event) => {
  // if (
  //   !cartDrawer.contains(event.target) &&
  //   event.target != cartOpenButton &&
  //   cartDrawer.classList.contains("open")
  // ) {
  //   cartDrawer.classList.remove("open");
  // }
});

function attachButtonListeners() {
  document.querySelectorAll(".add").forEach((button) => {
    button.addEventListener("click", (event) => {
      const curQuantity = Number(
        event.target.parentElement.children[1].getAttribute("data-quantity")
      );
      // updateQuantity(event.target.dataset.index, event.target.dataset.variantId, curQuantity + 1);
      updateCartItem(event.target.dataset.index, curQuantity + 1);
    });
  });

  document.querySelectorAll(".subtract").forEach((button) => {
    button.addEventListener("click", (event) => {
      const curQuantity = Number(
        event.target.parentElement.children[1].getAttribute("data-quantity")
      );
      updateCartItem(event.target.dataset.index, curQuantity - 1);

      // updateQuantity(event.target.dataset.index, event.target.dataset.variantId, curQuantity - 1);
    });
  });
  document.querySelectorAll(".deleteLine").forEach((button) => {
    button.addEventListener("click", (event) => {
      updateCartItem(button.dataset.index, 0);

      // updateCartItem(event.target.dataset.index, event.target.dataset.variantId, 0);
    });
  });
}

function disableAllButtons() {
  Array.from(cartDrawer.querySelectorAll("button")).forEach(
    (button, bIndex) => {
      button.disabled = true;
    }
  );
}
function enableAllButtons() {
  Array.from(cartDrawer.querySelectorAll("button")).forEach(
    (button, bIndex) => {
      button.disabled = false;
    }
  );
}

//   End Event Listeners ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`

// Fetch Functions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function updateCartItem(line, quantity) {
  disableAllButtons();
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line, quantity }),
  })
    .then((response) => response.json())
    .then((cart) => {
      renderCart(cart); // Update cart UI
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

function fetchCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => renderCart(cart))
    .catch((error) => console.error("Error fetching cart:", error));
}

// End Fetch Functions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// Render functions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function renderListItem(item, lineIndex) {
  // console.log(item)
  // <p class="cartLineVariant">${item.selling_plan_allocation.selling_plan.name}</p>

  const li = ` 
    <div class="cartLineImageCtn">
    
      <img src="${
        item.featured_image.url
      }&width=100" class="cartLineImage" alt="${item.title}" width="100" />
    </div>

          <div class="cartLineCtn">
            <p class="cartLineTitle">${item.product_title}</p>
            ${
              item.variant_title
                ? `<p class="cartLineVariant">${item.variant_title}</p>`
                : ""
            }
            ${
              item.selling_plan_allocation
                ? `<p class="cartLineVariant">${item.selling_plan_allocation.selling_plan.name}</p>`
                : ""
            }
            <div class="cartLineQuantityCtn">
              <button class="subtract" data-variant-id="${
                item.id
              }" data-index="${lineIndex + 1}">
                -
              </button>
              <span class="quantity" data-quantity="${item.quantity}">${
    item.quantity
  }</span>
              <button class="add" data-variant-id="${item.id}" data-index="${
    lineIndex + 1
  }">+</button>
            </div>
          </div>
          <div class="cartLineRight">
            <button class="deleteLine" data-variant-id="${
              item.id
            }" data-index="${lineIndex + 1}">Delete</button>
            <p class="lineTotal">${formatMoneyWithCurrency(item.line_price)}</p>
          </div>
      `;
  return li;
}

function formatMoneyWithCurrency(
  amountInCents,
  currencyCode = "USD",
  locale = "en-US"
) {
  // Convert cents to the base currency value
  const amount = amountInCents / 100;

  // Use the Intl.NumberFormat API to format the currency
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  }).format(amount);
}

function renderCart(cart) {
  if (cart.status == 422) {
    window.alert("No more products in stock");
  enableAllButtons();
    return;
  }
  enableAllButtons();
  cartItemsContainer.innerHTML = "";
  if (cart.items.length == 0) {
    cartItemsContainer.innerHTML = `<li class="noCartItems">No items in cart. <a href="/" class="noCartItemsLink" aria-label="Return home">Return home</a></li>`;
    return;
  }
  cart.items.forEach((item, lineIndex) => {
    const listItem = document.createElement("li");
    listItem.classList.add("cartLine");
    listItem.innerHTML = renderListItem(item, lineIndex);
    cartItemsContainer.appendChild(listItem);
  });
  cartTotal.children[0].textContent = `${formatMoneyWithCurrency(
    cart.total_price
  )}`;

  attachButtonListeners(); // Attach event listeners again
}
// End Render Functions ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// Fetch and render the cart on page load
fetchCart();
